import React, { PropTypes, Component } from 'react';

// Stylesheet
import './EmbeddedWebview.css';

class EmbeddedWebview extends Component {
  render() {
    return (
      <div className="EmbeddedWebview">
        <iframe className="EmbeddedWebview__frame" src={this.props.src}></iframe>
      </div>
    );
  }
};

EmbeddedWebview.propTypes = {
  src: PropTypes.string.isRequired
};

export default EmbeddedWebview;



// WEBPACK FOOTER //
// ./src/components/EmbeddedWebview.js